import React, { useEffect, useState } from "react";

// fixtureDetail hardcode đã xóa — chỉ dùng data thật từ bet.steamPressure

const ANALYSIS_ODDS_FORMAT_KEY = "analysis_options_odds_format";

function readOddsFormat() {
  try {
    const v = localStorage.getItem(ANALYSIS_ODDS_FORMAT_KEY);
    if (v && ["hk", "decimal", "american"].includes(v.toLowerCase())) return v.toLowerCase();
  } catch { /* ignore */ }
  return "hk";
}

function formatOddsForDisplay(rawOdds, fmt) {
  const raw = Number(rawOdds);
  if (!Number.isFinite(raw) || raw <= 0) return "—";
  // Auto-detect: nếu raw > 1 thì là decimal odds, nếu raw <= 1 thì là HK odds đã
  // Pinnacle backend có thể gửi cả 2 format
  const dec = raw > 1 ? raw : raw + 1; // normalize về decimal
  const hk  = dec - 1;                  // HK = decimal - 1
  const f = (fmt || "hk").toLowerCase();
  if (f === "decimal") return dec.toFixed(3);
  if (f === "american") {
    if (dec >= 2) return `+${Math.round((dec - 1) * 100)}`;
    if (dec > 1)  return `${Math.round(-100 / (dec - 1))}`;
    return "—";
  }
  // HK default
  if (hk <= 0) return "—"; // guard: HK không thể âm hoặc bằng 0
  return hk.toFixed(3);
}

const styles = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#050814",
    display: "flex",
    justifyContent: "center",
    padding: "12px",
    fontFamily: '"JetBrains Mono", "IBM Plex Mono", "SF Mono", "Roboto Mono", monospace',
    boxSizing: "border-box",
  },
  inner: {
    width: "100%",
    maxWidth: "100%",
  },
  card: {
    position: "relative",
    background:
      "radial-gradient(circle at 18% 0%, rgba(255,255,255,0.08) 0%, transparent 28%), linear-gradient(180deg, #222a36 0%, #171d27 48%, #111722 100%)",
    border: "1px solid rgba(255,255,255,0.10)",
    borderRadius: "14px",
    padding: "12px",
    color: "#f2f7ff",
    overflow: "hidden",
  },
  divider: {
    borderTop: "1px solid rgba(255,255,255,0.12)",
    margin: "10px 0",
  },
  headerRow1: {
    display: "grid",
    gridTemplateColumns: "1fr auto 1fr",
    alignItems: "center",
    marginBottom: "4px",
  },
  headerTeamHome: {
    fontSize: "13px",
    fontWeight: 700,
    color: "#f2f7ff",
    textAlign: "left",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  headerScore: {
    fontSize: "12.5px",
    fontWeight: 600,
    color: "rgba(242,247,255,0.55)",
    textAlign: "center",
    padding: "0 6px",
    whiteSpace: "nowrap",
  },
  headerTeamAway: {
    fontSize: "13px",
    fontWeight: 700,
    color: "#f2f7ff",
    textAlign: "right",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  headerRow2: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerMarket: {
    fontSize: "11.5px",
    color: "rgba(242,247,255,0.55)",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginRight: "8px",
  },
  headerBookmaker: {
    fontSize: "11.5px",
    fontWeight: 800,
    color: "#facc15",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  pressureSection: {
    display: "flex",
    flexDirection: "column",
    gap: "3px",
  },
  pressureRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    alignItems: "center",
    fontSize: "12px",
    lineHeight: "1.6",
  },
  pressureLabel: {
    color: "rgba(242,247,255,0.55)",
    textAlign: "left",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  pressureHome: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
    color: "#f2f7ff",
    fontWeight: 600,
    minWidth: 0,
  },
  pressureHomeName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
    flexShrink: 1,
  },
  pressureHomePct: {
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  pressureAway: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "4px",
    color: "#66db8d",
    fontWeight: 700,
    minWidth: 0,
  },
  pressureAwayName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
    flexShrink: 1,
  },
  pressureAwayPct: {
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "6px",
  },
  sectionTitle: {
    fontSize: "11.5px",
    fontWeight: 700,
    color: "rgba(242,247,255,0.70)",
    letterSpacing: "0.04em",
    textTransform: "uppercase",
  },
  sectionPercent: {
    fontSize: "12.5px",
    fontWeight: 700,
    color: "#66db8d",
  },
  historySection: {
    marginBottom: "4px",
  },
  historyItem: {
    display: "grid",
    gridTemplateColumns: "110px 1fr",
    borderTop: "1px solid rgba(255,255,255,0.08)",
  },
  historyTimeCol: {
    padding: "6px 8px 6px 0",
    borderRight: "1px solid rgba(255,255,255,0.16)",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  historyTime: {
    fontSize: "12px",
    color: "rgba(242,247,255,0.50)",
    whiteSpace: "nowrap",
  },
  historyContentCol: {
    padding: "6px 0 6px 10px",
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    minWidth: 0,
  },
  historyLine1: {
    fontSize: "12px",
    color: "#f2f7ff",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  historyLine2: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    flexWrap: "nowrap",
    overflow: "hidden",
  },
  historyLineLabel: {
    fontSize: "11.5px",
    color: "rgba(242,247,255,0.45)",
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  historyOdds: {
    fontSize: "12px",
    color: "hsla(50, 83%, 54%, 0.91)",
    fontWeight: 600,
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  historyDcm: {
    fontSize: "12px",
    color: "#34d17a",
    fontWeight: 700,
    whiteSpace: "nowrap",
    flexShrink: 0,
    marginLeft: "auto",
  },
};

function PressureRow({ label, home, away, homeLabel, awayLabel }) {
  // Bên nào % cao hơn → xanh, bên còn lại → cam
  const homeColor = home >= away ? "#66db8d" : "#f97316";
  const awayColor = away >= home ? "#66db8d" : "#f97316";

  return (
    <div style={styles.pressureRow}>
      <span style={styles.pressureLabel}>{label}</span>

      {/* Home: tên trắng + % màu theo tỷ lệ */}
      <span style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        gap: "4px", minWidth: 0, overflow: "hidden",
      }}>
        <span style={{
          color: "#f2f7ff", fontWeight: 600,
          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
          minWidth: 0, flexShrink: 1,
        }}>{homeLabel}</span>
        <span style={{
          color: homeColor, fontWeight: 700,
          whiteSpace: "nowrap", flexShrink: 0,
        }}>{Math.min(100, Math.round(home * 10) / 10)}%</span>
      </span>

      {/* Away: tên trắng + % màu theo tỷ lệ */}
      <span style={{
        display: "flex", alignItems: "center", justifyContent: "flex-end",
        gap: "4px", minWidth: 0, overflow: "hidden",
      }}>
        <span style={{
          color: "#f2f7ff", fontWeight: 600,
          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
          minWidth: 0, flexShrink: 1,
        }}>{awayLabel}</span>
        <span style={{
          color: awayColor, fontWeight: 700,
          whiteSpace: "nowrap", flexShrink: 0,
        }}>{Math.min(100, Math.round(away * 10) / 10)}%</span>
      </span>
    </div>
  );
}

function HistoryItem({ time, line, oldLine, newLine, lineMoveAbs, movementType, oddsFrom, oddsTo, dcm, adjustedDcm, isTotal }) {
  return (
    <div style={styles.historyItem} className="fdp-history-item">
      <div style={styles.historyTimeCol}>
        <span style={styles.historyTime} className="fdp-history-time">{time}</span>
      </div>
      <div style={styles.historyContentCol}>
        {movementType === "line_move" && oldLine != null && newLine != null ? (
          <div style={styles.historyLine2}>
            <span style={styles.historyLineLabel} className="fdp-history-line2">
              {`Line ${!isTotal && Number(oldLine) > 0 ? "+" : ""}${oldLine}`}
            </span>
            <span style={styles.historyLineLabel} className="fdp-history-line2">·</span>
            <span style={styles.historyOdds} className="fdp-history-line2">
              {oddsFrom}
            </span>
            <span style={styles.historyLineLabel} className="fdp-history-line2">→</span>
            <span style={styles.historyLineLabel} className="fdp-history-line2">
              {`${!isTotal && Number(newLine) > 0 ? "+" : ""}${newLine}`}
            </span>
            <span style={styles.historyLineLabel} className="fdp-history-line2">·</span>
            <span style={styles.historyOdds} className="fdp-history-line2">
              {oddsTo}
            </span>
          </div>
        ) : (
          <div style={styles.historyLine2}>
            {line != null && line !== "" && (
              <span style={styles.historyLineLabel} className="fdp-history-line2">
                Line {line}
              </span>
            )}
            <span style={styles.historyOdds} className="fdp-history-line2">
              {oddsFrom} → {oddsTo}
            </span>
            <span style={styles.historyDcm} className="fdp-history-line2">
              {dcm}
            </span>
            {adjustedDcm && (
              <span style={{
                fontSize: "11px",
                color: "rgba(102,219,141,0.65)",
                fontWeight: 600,
                whiteSpace: "nowrap",
                flexShrink: 0,
                marginLeft: "4px",
              }}>
                ↳{adjustedDcm}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function SuspendEventItem({ type, timeStr, minute }) {
  const isClose = type === "suspend";
  return (
    <div style={{
      ...styles.historyItem,
      background: isClose
        ? "rgba(249,115,22,0.06)"
        : "rgba(102,219,141,0.06)",
      borderTop: isClose
        ? "1px solid rgba(249,115,22,0.12)"
        : "1px solid rgba(102,219,141,0.12)",
    }} className="fdp-history-item">
      <div style={styles.historyTimeCol}>
        <span style={{
          ...styles.historyTime,
          color: isClose
            ? "rgba(249,115,22,0.8)"
            : "rgba(102,219,141,0.7)",
        }}>
          {minute != null ? `${minute}'` : (timeStr || "—")}
        </span>
      </div>
      <div style={styles.historyContentCol}>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span style={{
            fontSize: "12px",
            fontWeight: 600,
            color: isClose
              ? "rgba(249,115,22,0.9)"
              : "rgba(102,219,141,0.9)",
          }}>
            {isClose ? "⛔ Đóng kèo tạm thời" : "✅ Mở lại kèo"}
          </span>
          {timeStr && (
            <span style={{ fontSize: "11px", color: "rgba(242,247,255,0.35)" }}>
              {timeStr}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

function withReboundMarkers(lineItems, sideLabel, signedLine) {
  const out = [];

  for (let i = 0; i < lineItems.length; i++) {
    const cur  = lineItems[i];
    const prev = i > 0 ? lineItems[i - 1] : null;

    const prevNew = Number(prev?.rawNewOdds);
    const curOld  = Number(cur?.rawOldOdds);

    if (
      prev &&
      cur.movementType  !== "line_move" &&
      prev.movementType !== "line_move" &&
      Number.isFinite(prevNew) &&
      Number.isFinite(curOld) &&
      Math.abs(prevNew - curOld) > 0.001
    ) {
      out.push({
        id: `rb-${sideLabel}-${signedLine ?? "no-line"}-${i}`,
        isReboundMarker: true,
        reboundFrom: prev.oddsTo  ?? String(prevNew),
        reboundTo:   cur.oddsFrom ?? String(curOld),
      });
    }

    out.push(cur);
  }

  return out;
}

function SideHistorySection({ sideLabel, market, percent, items, summary }) {
  if (!items || items.length === 0) return null;

  return (
    <div style={styles.historySection}>
      <div style={styles.sectionHeader}>
        <span style={styles.sectionTitle}>
          {sideLabel}{market ? ` · ${market}` : ""}
        </span>
        {percent != null && percent !== "—" && (
          <span style={styles.sectionPercent}>{percent}</span>
        )}
      </div>
      {summary && summary.dropCount > 0 && (
        <div style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "4px 8px",
          padding: "6px 0",
          borderTop: "1px solid rgba(255,255,255,0.08)",
          fontSize: "10.5px",
          color: "rgba(242,247,255,0.48)",
        }}>
          <span>Drop đầu: <b style={{ color: "rgba(242,247,255,0.75)" }}>{summary.firstDropAt}</b></span>
          <span>Mới nhất: <b style={{ color: "rgba(242,247,255,0.75)" }}>{summary.latestDropAt}</b></span>
          <span>Số lần: <b style={{ color: "rgba(242,247,255,0.75)" }}>{summary.dropCount}</b></span>
          <span>Mạnh nhất: <b style={{ color: "#66db8d" }}>+{summary.maxSingleDrop.toFixed(2)}%</b></span>
        </div>
      )}
      {items.map((item, idx) => (
        item.isLineHeader ? (
          <div
            key={item.id || idx}
            style={{
              fontSize: "10.5px",
              color: item.isCurrent ? "rgba(102,219,141,0.7)" : "rgba(242,247,255,0.38)",
              padding: "5px 8px 2px",
              fontWeight: 600,
              letterSpacing: "0.04em",
              textTransform: "uppercase",
              borderTop: "1px solid rgba(255,255,255,0.06)",
              marginTop: "4px",
            }}
          >
            {item.lineLabel}
          </div>
        ) : item.isReboundMarker ? (
          <div
            key={item.id || idx}
            style={{
              fontSize: "11px",
              color: "rgba(242,247,255,0.35)",
              padding: "2px 8px 4px",
              fontStyle: "italic",
              borderTop: "1px solid rgba(255,255,255,0.05)",
            }}
          >
            ↳ Odds hồi/reset trước drop sau: {item.reboundFrom} → {item.reboundTo}
          </div>
        ) : (
          <HistoryItem key={item.id || idx} {...item} />
        )
      ))}
    </div>
  );
}

function getPairFilterMeta(bet) {
  const abs = bet?.mainLinePairAbs != null
    ? Math.round(Math.abs(Number(bet.mainLinePairAbs)) * 1000) / 1000
    : null;
  const line = bet?.mainLinePairLine != null
    ? Math.round(Number(bet.mainLinePairLine) * 1000) / 1000
    : null;
  const marketRaw = String(
    bet?.marketFamily ||
    bet?.market_family ||
    bet?.market ||
    bet?.market_type ||
    bet?.marketType ||
    ""
  ).toLowerCase();
  const isTotal =
    marketRaw.includes("total") ||
    marketRaw.includes("over_under") ||
    marketRaw.includes("goals");
  const isSpread =
    marketRaw.includes("spread") ||
    marketRaw.includes("handicap");
  return { abs, line, isTotal, isSpread };
}

function isDropInCurrentPair(dr, bet) {
  if (!dr) return false;
  if (dr.movementType === "line_move") return false;
  const { abs, line, isTotal, isSpread } = getPairFilterMeta(bet);
  const rawLine = dr.line ?? dr.newLine ?? dr.oldLine;
  const n = Number(rawLine);
  if (!Number.isFinite(n)) return true;
  const rounded    = Math.round(n * 1000) / 1000;
  const roundedAbs = Math.round(Math.abs(n) * 1000) / 1000;
  if (isSpread && abs != null) {
    return Math.abs(roundedAbs - abs) < 0.001;
  }
  if (isTotal && line != null) {
    return Math.abs(rounded - line) < 0.001;
  }
  return true;
}

function renderPrematchSideHistorySections(prematchBySide, marketLabel, bet) {
  const { abs, line: currentLine, isTotal, isSpread } = getPairFilterMeta(bet);
  // canDetermineStatus — chỉ gắn nhãn khi có đủ dữ liệu để so sánh
  const canDetermineStatus = (isSpread && abs != null) || (isTotal && currentLine != null);

  return prematchBySide.map((s) => {
    const lineMap = new Map();

    for (const item of s.drops || []) {
      const k = item.signedLine ?? "__no_line__";
      if (!lineMap.has(k)) lineMap.set(k, []);
      lineMap.get(k).push(item);
    }

    const lineEntries = Array.from(lineMap.entries());

    if (lineEntries.length <= 1) {
      const [sl, lineItems] = lineEntries[0] || ["__no_line__", s.drops || []];

      return (
        <SideHistorySection
          key={s.sideLabel}
          sideLabel={s.sideLabel}
          market={marketLabel}
          percent={null}
          items={withReboundMarkers(lineItems, s.sideLabel, sl)}
          summary={s.summary}
        />
      );
    }

    // Multiple lines: ONE section per side, line sub-headers bên trong
    const mergedItems = [];
    for (const [sl, lineItems] of lineEntries) {
      let isCurrent = false;
      if (canDetermineStatus && sl !== "__no_line__" && sl != null) {
        const slNum = Number(sl);
        if (Number.isFinite(slNum)) {
          if (isSpread && abs != null) isCurrent = Math.abs(Math.abs(slNum) - abs) < 0.001;
          else if (isTotal && currentLine != null) isCurrent = Math.abs(slNum - currentLine) < 0.001;
        }
      }
      const lineStr = sl !== "__no_line__" && sl != null
        ? `Line ${Number(sl) > 0 ? "+" : ""}${sl}`
        : null;
      mergedItems.push(...withReboundMarkers(lineItems, s.sideLabel, sl));
    }
    return (
      <SideHistorySection
        key={s.sideLabel}
        sideLabel={s.sideLabel}
        market={marketLabel}
        percent={null}
        items={mergedItems}
        summary={s.summary}
      />
    );
  });
}

export default function FixtureDetailPage({ bet, onClose, oddsFormat: oddsFormatProp }) {
  const [_oddsFormat, _setOddsFormat] = React.useState(() => oddsFormatProp || readOddsFormat());
  React.useEffect(() => {
    function sync() {
      const next = oddsFormatProp || readOddsFormat();
      _setOddsFormat((prev) => (prev !== next ? next : prev));
    }
    window.addEventListener("storage", sync);
    window.addEventListener("analysis_odds_format_changed", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("analysis_odds_format_changed", sync);
    };
  }, [oddsFormatProp]);
  const oddsFormat = _oddsFormat;

  const pressure = bet?.steamPressure;
  const sidesValues = pressure?.sides
    ? Object.values(pressure.sides)
    : [];
  const homeSide = sidesValues[0] ?? null;
  const awaySide = sidesValues[1] ?? null;

  const marketLabel = bet?.market
    ? bet.market.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    : "";

  const getDropScope = (dr) => {
    if (dr.dropScope === "live") return "live";
    if (dr.dropScope === "prematch") return "prematch";
    if (dr.matchMinute != null || dr.minute != null) return "live";
    if (dr.phase && dr.phase !== "prematch" && dr.phase !== null) return "live";
    return "prematch";
  };

  const getDropDedupKey = (dr) => [
    getDropScope(dr),
    dr.minute ?? dr.matchMinute ?? "",
    dr.stableKey || "",
    dr.side || dr.selectionSide || "",
    dr.oldOdds ?? "",
    dr.newOdds ?? "",
    dr.oldLine ?? "",
    dr.newLine ?? "",
    dr.movementType ?? "",
  ].join("|");

  const getDropTimeMs = (dr) => {
    const ts = dr?.detectedAt || dr?.recordedAt || null;
    if (!ts) return null;
    const ms = new Date(ts).getTime();
    return Number.isFinite(ms) ? ms : null;
  };

  const pressureSummary = React.useMemo(() => {
    if (!pressure?.sides) {
      return {
        total:    { home: 0, away: 0 },
        prematch: { home: 0, away: 0 },
        live:     { home: 0, away: 0 },
      };
    }
    const sides = Object.values(pressure.sides);

    const sideCums = sides.map((sideData) => {
      const drops = Array.isArray(sideData?.drops) ? sideData.drops : [];

      const dedup = (dropsArr) => {
        const byTs = new Map();
        for (const dr of dropsArr) {
          const tsKey = getDropDedupKey(dr);
          const pct = dr.singleDropPct ?? dr.dropPct ?? 0;
          if (!byTs.has(tsKey) || pct > (byTs.get(tsKey).singleDropPct ?? byTs.get(tsKey).dropPct ?? 0)) {
            byTs.set(tsKey, dr);
          }
        }
        return Array.from(byTs.values());
      };

      const pressureDrops = drops.filter(
        (d) =>
          d.excludeFromPressure !== true &&
          d.movementType !== "line_move" &&
          isDropInCurrentPair(d, bet)
      );
      const visibleDrops  = dedup(pressureDrops);
      const prematchDrops = dedup(pressureDrops.filter((d) => getDropScope(d) === "prematch"));
      const liveDrops     = dedup(pressureDrops.filter((d) => getDropScope(d) === "live"));

      const total    = visibleDrops .reduce((s, d) => s + (d.singleDropPct ?? d.dropPct ?? 0), 0);
      const prematch = prematchDrops.reduce((s, d) => s + (d.singleDropPct ?? d.dropPct ?? 0), 0);
      const live     = liveDrops   .reduce((s, d) => s + (d.singleDropPct ?? d.dropPct ?? 0), 0);

      return { total, prematch, live, label: sideData.label || "" };
    });

    const totalAll  = sideCums.reduce((s, c) => s + c.total,    0);
    const totalPre  = sideCums.reduce((s, c) => s + c.prematch, 0);
    const totalLive = sideCums.reduce((s, c) => s + c.live,     0);
    const pct = (num, den) => den > 0 ? Math.min(100, Math.round((num / den) * 1000) / 10) : 0;

    const homeNorm = (bet?.homeTeam ?? bet?.home ?? "").trim().toLowerCase();
    const awayNorm = (bet?.awayTeam ?? bet?.away ?? "").trim().toLowerCase();
    const homeIdx = sideCums.findIndex((s) =>
      s.label.trim().toLowerCase().includes(homeNorm.slice(0, 5))
    );
    const awayIdx = sideCums.findIndex((s, i) =>
      i !== homeIdx && s.label.trim().toLowerCase().includes(awayNorm.slice(0, 5))
    );
    const hi = homeIdx >= 0 ? homeIdx : 0;
    const ai = awayIdx >= 0 ? awayIdx : (hi === 0 ? 1 : 0);
    const home = sideCums[hi] ?? { total: 0, prematch: 0, live: 0 };
    const away = sideCums[ai] ?? { total: 0, prematch: 0, live: 0 };

    return {
      total:    { home: pct(home.total,    totalAll),  away: pct(away.total,    totalAll)  },
      prematch: { home: pct(home.prematch, totalPre),  away: pct(away.prematch, totalPre)  },
      live:     { home: pct(home.live,     totalLive), away: pct(away.live,     totalLive) },
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bet]);

  const d = {
    homeTeam:  bet?.homeTeam  ?? bet?.home  ?? "",
    awayTeam:  bet?.awayTeam  ?? bet?.away  ?? "",
    homeScore: bet?.homeScore ?? null,
    awayScore: bet?.awayScore ?? null,
    minute: (() => {
      const _clock = bet?.gameClock != null && String(bet.gameClock).trim()
        ? String(bet.gameClock)
        : null;
      const _liveMin = bet?.minute ?? bet?.matchMinute ?? null;
      return _clock ?? (_liveMin != null ? `${_liveMin}'` : "");
    })(),
    market:    marketLabel,
    bookmaker: bet?.bookmaker ?? "",
    pressure: pressureSummary,
  };

  const buildSideHistory = (phaseFilter) => {
    if (!pressure?.sides) return [];
    return Object.values(pressure.sides).map((sideData) => {
      const drops = Array.isArray(sideData?.drops) ? sideData.drops : [];
      // Filter theo phase prematch/live — không filter marketScope
      // vì drops trong steamPressure.sides không có stableKey field
      // Tách hiệp đã được handle ở aggregate card level
      const filteredRaw = drops
        .filter((dr) => getDropScope(dr) === phaseFilter)
        .filter((dr) => {
          if (!dr) return false;
          // Full history display — không filter theo current pair
          // Signed-line grouping đã xử lý tách biệt line +0.5 vs -0.5
          if (dr.movementType === "line_move") {
            return dr.oldLine != null || dr.newLine != null;
          }
          return true;
        });

      // Dedup theo timestamp: cùng giây chỉ giữ drop có dropPct lớn nhất
      const dedupedRaw = (() => {
        const byTs = new Map();
        for (const dr of filteredRaw) {
          const tsKey = getDropDedupKey(dr);
          const pct = dr.singleDropPct ?? dr.dropPct ?? 0;
          if (!byTs.has(tsKey) || pct > (byTs.get(tsKey).singleDropPct ?? byTs.get(tsKey).dropPct ?? 0)) {
            byTs.set(tsKey, dr);
          }
        }
        return Array.from(byTs.values());
      })();

      const visibleCumDrop = dedupedRaw
        .filter((d) => d.movementType !== "line_move")
        .reduce((s, d) => s + (d.singleDropPct ?? d.dropPct ?? 0), 0);

      const _oddsDropsOnly = dedupedRaw.filter((d) => d.movementType !== "line_move");
      const _firstDropTs = _oddsDropsOnly.reduce((min, d) => {
        const t = getDropTimeMs(d);
        if (t == null) return min;
        return min == null || t < min ? t : min;
      }, null);
      const _latestDropTs = _oddsDropsOnly.reduce((max, d) => {
        const t = getDropTimeMs(d);
        if (t == null) return max;
        return max == null || t > max ? t : max;
      }, null);
      const _maxSingleDrop = _oddsDropsOnly.reduce((mx, d) => {
        const pct = Number(d.singleDropPct ?? d.dropPct ?? 0);
        return Number.isFinite(pct) ? Math.max(mx, pct) : mx;
      }, 0);
      const _fmtSummaryTs = (ms) => {
        if (ms == null) return "—";
        return new Date(ms).toLocaleString("vi-VN", {
          hour: "2-digit", minute: "2-digit", second: "2-digit",
        });
      };
      const _dropSummary = {
        firstDropAt:  _fmtSummaryTs(_firstDropTs),
        latestDropAt: _fmtSummaryTs(_latestDropTs),
        dropCount:    _oddsDropsOnly.length,
        maxSingleDrop: _maxSingleDrop,
      };

      const filtered = dedupedRaw
        .sort((a, b) => {
          if (phaseFilter !== "prematch") {
            const aMin = a.minute ?? a.matchMinute ?? null;
            const bMin = b.minute ?? b.matchMinute ?? null;

            if (aMin != null && bMin != null) {
              const aNum = Number(aMin);
              const bNum = Number(bMin);
              if (Number.isFinite(aNum) && Number.isFinite(bNum) && aNum !== bNum) {
                return aNum - bNum;
              }
            }

            // Một hoặc cả hai thiếu minute → fallback timestamp
            const liveTA = getDropTimeMs(a);
            const liveTB = getDropTimeMs(b);
            if (liveTA != null && liveTB != null) return liveTA - liveTB;
            if (liveTA != null) return -1;
            if (liveTB != null) return 1;

            // Không có timestamp: drop có minute đứng trước drop không có gì
            if (aMin != null && bMin == null) return -1;
            if (aMin == null && bMin != null) return 1;
            return 0;
          }

          const tA = getDropTimeMs(a);
          const tB = getDropTimeMs(b);
          if (tA != null && tB != null) return tA - tB;
          if (tA != null) return -1;
          if (tB != null) return 1;
          return 0;
        })
        .map((dr, i) => ({
          id: `${sideData.label || "side"}-${phaseFilter}-${i}`,
          time: getDropScope(dr) === "prematch"
            ? (() => {
                const ts = dr.detectedAt || dr.recordedAt || null;
                return ts
                  ? new Date(ts).toLocaleString("vi-VN", {
                      day: "2-digit", month: "2-digit",
                      hour: "2-digit", minute: "2-digit", second: "2-digit",
                    })
                  : "—";
              })()
            : ((dr.minute ?? dr.matchMinute) != null
                ? `${dr.minute ?? dr.matchMinute}'`
                : (() => {
                    const ts = dr.detectedAt || dr.recordedAt || null;
                    return ts
                      ? new Date(ts).toLocaleString("vi-VN", {
                          hour: "2-digit", minute: "2-digit", second: "2-digit",
                        })
                      : "Live";
                  })()),
          isTotal: getPairFilterMeta(bet).isTotal,
          line: dr.line != null ? String(dr.line) : null,
          oldLine: dr.oldLine != null ? String(dr.oldLine) : null,
          newLine: dr.newLine != null ? String(dr.newLine) : null,
          lineMoveAbs: dr.lineMoveAbs ?? null,
          movementType: dr.movementType ?? null,
          oddsFrom: dr.oldOdds != null ? formatOddsForDisplay(dr.oldOdds, oddsFormat) : "—",
          oddsTo:   dr.newOdds != null ? formatOddsForDisplay(dr.newOdds, oddsFormat) : "—",
          signedLine: (() => {
            const rawL = dr.line ?? dr.newLine ?? dr.oldLine;
            const n = Number(rawL);
            return Number.isFinite(n)
              ? String(Math.round(n * 1000) / 1000)
              : null;
          })(),
          rawOldOdds: dr.oldOdds ?? null,
          rawNewOdds: dr.newOdds ?? null,
          dcm: dr.singleDropPct != null
            ? `+${dr.singleDropPct.toFixed(2)}%`
            : (dr.dropPct != null ? `+${dr.dropPct.toFixed(2)}%` : "—"),
          adjustedDcm: (() => {
            if (dr.phase === null) return null;
            if (dr.adjustedDropPct == null) return null;
            return `+${dr.adjustedDropPct.toFixed(2)}%`;
          })(),
        }));
      return {
        sideLabel: sideData.label || "—",
        visibleCumDrop,
        summary: _dropSummary,
        drops: filtered,
      };
    }).filter((s) => s.drops.length > 0);
  };

  const prematchBySide = React.useMemo(
    () => buildSideHistory("prematch"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [bet, _oddsFormat]
  );
  const liveBySide = React.useMemo(
    () => buildSideHistory("live"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [bet, _oddsFormat]
  );

  // Build suspend rows — mỗi event tạo 1-2 dòng riêng (đóng + mở lại)
  const suspendRows = (() => {
    const events = Array.isArray(pressure?.suspendEvents)
      ? pressure.suspendEvents.filter((e) => e.phase !== null)
      : [];
    const rows = [];
    const formatTs = (ts) => ts
      ? new Date(ts).toLocaleString("vi-VN", {
          day: "2-digit", month: "2-digit",
          hour: "2-digit", minute: "2-digit", second: "2-digit",
        })
      : null;
    for (const ev of events) {
      // Dòng 1 — đóng kèo
      if (ev.suspendAt) {
        rows.push({
          type: "suspend",
          timeStr: formatTs(ev.suspendAt),
          minute:  ev.minute ?? null,
          sortTs:  new Date(ev.suspendAt).getTime(),
        });
      }
      // Dòng 2 — mở lại kèo
      if (ev.resumeAt) {
        rows.push({
          type: "resume",
          timeStr: formatTs(ev.resumeAt),
          minute:  null,
          sortTs:  new Date(ev.resumeAt).getTime(),
        });
      }
    }
    return rows.sort((a, b) => a.sortTs - b.sortTs);
  })();
  const [closing, setClosing] = useState(false);

  const handleClose = () => {
    if (!onClose) return;
    setClosing(true);
    setTimeout(() => { onClose(); }, 270); // khớp fdpSheetOut 0.28s
  };

  // Đóng khi bấm Escape
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") handleClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div
      className={closing ? "fdp-fullscreen-panel fdp-sheet-out" : "fdp-fullscreen-panel fdp-sheet-in"}
      onClick={(e) => e.stopPropagation()}
    >
      <style>{`
        @keyframes fdpBackdropIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
        @keyframes fdpBackdropOut {
          from { opacity: 1; }
          to   { opacity: 0; }
        }
        @keyframes fdpSheetIn {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes fdpSheetOut {
          from { opacity: 1; transform: translateY(0); }
          to   { opacity: 0; transform: translateY(12px); }
        }
        .fdp-backdrop-in  { animation: fdpBackdropIn  0.22s ease both; }
        .fdp-backdrop-out { animation: fdpBackdropOut 0.20s ease both; }
        .fdp-sheet-in  { animation: fdpSheetIn  0.22s cubic-bezier(0.22,1,0.36,1) both; }
        .fdp-sheet-out { animation: fdpSheetOut 0.18s cubic-bezier(0.4,0,1,1) both; }
        @media (max-width: 430px) {
          .fdp-card { padding: 10px !important; }
          .fdp-history-item { grid-template-columns: 104px 1fr !important; }
          .fdp-history-time { font-size: 11px !important; }
          .fdp-history-line1 { font-size: 11px !important; }
          .fdp-history-line2 span { font-size: 11px !important; }
          .fdp-pressure-row { font-size: 11px !important; }
        }
        .fdp-fullscreen-panel {
          position: relative;
          width: 100%;
          max-width: 100%;
          height: 100dvh;
          max-height: 100dvh;
          margin: 0 auto;
          background: #050814;
          color: #f2f7ff;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          box-sizing: border-box;
          font-family: "JetBrains Mono","IBM Plex Mono","SF Mono","Roboto Mono",monospace;
        }
        .fdp-sticky-header {
          position: sticky;
          top: 0;
          z-index: 20;
          height: 46px;
          min-height: 46px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 12px;
          box-sizing: border-box;
          background: linear-gradient(180deg,rgba(14,22,42,0.98) 0%,rgba(5,8,20,0.96) 100%);
          border-bottom: 1px solid rgba(255,255,255,0.10);
          box-shadow: 0 8px 18px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.045);
          backdrop-filter: blur(8px);
        }
        .fdp-sticky-title {
          color: #f2f7ff;
          font-size: 13px;
          font-weight: 800;
          letter-spacing: 0.04em;
          text-transform: uppercase;
        }
        .fdp-close-button {
          width: 32px; height: 32px;
          border-radius: 10px;
          border: 1px solid rgba(255,255,255,0.12);
          background: rgba(255,255,255,0.06);
          color: #f2f7ff;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          font-weight: 800;
          line-height: 1;
          cursor: pointer;
          padding: 0;
        }
        .fdp-close-button:active { transform: translateY(1px); }
        .fdp-scroll-body {
          flex: 1 1 auto;
          overflow-y: auto;
          overflow-x: hidden;
          padding: 10px 10px calc(18px + env(safe-area-inset-bottom, 0px));
          box-sizing: border-box;
          -webkit-overflow-scrolling: touch;
        }
      `}</style>
      <div className="fdp-sticky-header">
        <div className="fdp-sticky-title">Steam Detail</div>
        <button
          type="button"
          className="fdp-close-button"
          onClick={handleClose}
          aria-label="Đóng chi tiết"
          title="Đóng"
        >
          ✕
        </button>
      </div>
      <div className="fdp-scroll-body">
      <div style={styles.inner}>
        <div style={styles.card} className="fdp-card">

          {/* Header */}
          <div style={styles.headerRow1}>
            <span style={styles.headerTeamHome}>
              {d.homeTeam} {d.homeScore}
            </span>
            <span style={styles.headerScore}>{d.minute}</span>
            <span style={styles.headerTeamAway}>
              {d.awayTeam} {d.awayScore}
            </span>
          </div>
          <div style={styles.headerRow2}>
            <span style={styles.headerMarket}>{d.market}</span>
            <span style={styles.headerBookmaker}>{d.bookmaker}</span>
          </div>

          <div style={styles.divider} />

          {/* Pressure */}
          <div style={styles.pressureSection}>
            <PressureRow
              label="Pressure Tổng"
              home={d.pressure.total.home}
              away={d.pressure.total.away}
              homeLabel={d.homeTeam}
              awayLabel={d.awayTeam}
            />
            <PressureRow
              label="Pressure Prematch"
              home={d.pressure.prematch.home}
              away={d.pressure.prematch.away}
              homeLabel={d.homeTeam}
              awayLabel={d.awayTeam}
            />
            <PressureRow
              label="Pressure Live"
              home={d.pressure.live.home}
              away={d.pressure.live.away}
              homeLabel={d.homeTeam}
              awayLabel={d.awayTeam}
            />
          </div>

          {/* Steam Direction */}
          {(() => {
            const allSides = [...prematchBySide, ...liveBySide];
            if (allSides.length === 0) return null;
            const total = allSides.reduce((s, x) => s + x.visibleCumDrop, 0);
            if (total === 0) return null;
            const byLabel = {};
            for (const s of allSides) {
              byLabel[s.sideLabel] = (byLabel[s.sideLabel] || 0) + s.visibleCumDrop;
            }
            const entries = Object.entries(byLabel).sort((a, b) => b[1] - a[1]);
            const [topLabel, topDrop] = entries[0];
            const topPct = Math.min(100, Math.round((topDrop / total) * 100));
            return (
              <div style={{
                marginTop: "6px",
                padding: "6px 10px",
                borderRadius: "8px",
                background: "rgba(102,219,141,0.10)",
                border: "1px solid rgba(102,219,141,0.25)",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
                <span style={{ fontSize: "11.5px", color: "rgba(242,247,255,0.6)" }}>
                  Steam đang về
                </span>
                <span style={{ fontSize: "13px", fontWeight: 700, color: "#66db8d" }}>
                  {topLabel} {topPct}%
                </span>
              </div>
            );
          })()}

          {bet?.hasLineShiftSignal === true && (() => {
            const openHk = bet.openingOdds != null
              ? (Number(bet.openingOdds) - 1).toFixed(2)
              : null;
            const closeHk = bet.closingOdds != null
              ? (Number(bet.closingOdds) - 1).toFixed(2)
              : null;
            const openTok = bet.openingLineValue != null
              ? (Number(bet.openingLineValue) > 0
                  ? `+${bet.openingLineValue}`
                  : String(bet.openingLineValue))
              : "—";
            const closeTok = bet.closingLineValue != null
              ? (Number(bet.closingLineValue) > 0
                  ? `+${bet.closingLineValue}`
                  : String(bet.closingLineValue))
              : "—";
            return (
              <div style={{
                marginTop: "8px",
                padding: "8px 10px",
                borderRadius: "8px",
                background: "rgba(250,204,21,0.08)",
                border: "1px solid rgba(250,204,21,0.22)",
                display: "flex",
                flexDirection: "column",
                gap: "3px",
              }}>
                <span style={{
                  fontSize: "10.5px", fontWeight: 800,
                  color: "#facc15", letterSpacing: "0.06em",
                  textTransform: "uppercase",
                }}>
                  LINE SHIFT PINNACLE · PREMATCH
                </span>
                <div style={{ fontSize: "12px", color: "rgba(242,247,255,0.75)", marginTop: "2px", display: "flex", flexDirection: "column", gap: "1px" }}>
                  <div>Cửa: <span style={{ color: "#f2f7ff", fontWeight: 600 }}>{bet.lineShiftSelection || "—"}</span></div>
                  <div>Market: <span style={{ color: "#f2f7ff", fontWeight: 600 }}>{bet.lineShiftMarket || "—"}</span></div>
                  <div>Opening line: <span style={{ color: "#f2f7ff", fontWeight: 600 }}>{openTok}</span></div>
                  <div>Closing line: <span style={{ color: "#f2f7ff", fontWeight: 600 }}>{closeTok}</span></div>
                  <div>Line shift: <span style={{ color: "#facc15", fontWeight: 700 }}>{Number(bet.lineShiftAbs || 0).toFixed(2)}</span></div>
                  {openHk && <div>Opening HK: <span style={{ color: "#f2f7ff", fontWeight: 600 }}>{openHk}</span></div>}
                  {closeHk && <div>Closing HK: <span style={{ color: "#f2f7ff", fontWeight: 600 }}>{closeHk}</span></div>}
                  <div style={{ color: "rgba(242,247,255,0.40)", fontSize: "11px", marginTop: "2px" }}>
                    Chốt lúc: kickoff - 5 phút · Book: Pinnacle
                  </div>
                </div>
              </div>
            );
          })()}

          {/* Main Line Milestones */}
          {(() => {
            const mlm = bet?._mainLineMilestones;
            const fmtLine = (v) => {
              if (v == null) return null;
              const n = Number(v);
              return Number.isFinite(n) ? (n > 0 ? `+${n}` : String(n)) : String(v);
            };
            const fmtOdds = (v) => {
              if (v == null) return null;
              const n = Number(v);
              return Number.isFinite(n) ? (n - 1).toFixed(2) : null;
            };
            const rows = [
              { label: "Mở kèo",         data: mlm?.openingMain    ?? null },
              { label: "Trước bóng lăn", data: mlm?.preKickoffMain ?? null },
              { label: "Hết H1",          data: mlm?.halftimeMain   ?? null },
            ];
            return (
              <div style={{ marginBottom: "6px" }}>
                <div style={styles.sectionHeader}>
                  <span style={styles.sectionTitle}>MAIN LINE MILESTONES</span>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                  {rows.map(({ label, data }) => {
                    const line = data ? fmtLine(data.line) : null;
                    const hk   = data ? fmtOdds(data.odds) : null;
                    return (
                      <div key={label} style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "3px 0",
                        borderTop: "1px solid rgba(255,255,255,0.07)",
                      }}>
                        <span style={{
                          fontSize: "11.5px",
                          color: "rgba(242,247,255,0.55)",
                          minWidth: "110px",
                        }}>{label}</span>
                        {data && line != null ? (
                          <span style={{ fontSize: "12px", fontWeight: 700, color: "#f2f7ff", textAlign: "right" }}>
                            {(() => {
                              const sel = data.selection || data.selectionSide || null;
                              const selLabel = sel
                                ? (sel.toLowerCase() === "home" ? data.homeTeam || "Home"
                                  : sel.toLowerCase() === "away" ? data.awayTeam || "Away"
                                  : sel)
                                : null;
                              return selLabel ? `${selLabel} · Line ${line}` : `Line ${line}`;
                            })()}
                            {hk != null && (
                              <span style={{ fontWeight: 400, color: "rgba(242,247,255,0.60)", marginLeft: "5px" }}>
                                {`HK ${hk}`}
                              </span>
                            )}
                          </span>
                        ) : (
                          <span style={{ fontSize: "11.5px", color: "rgba(242,247,255,0.28)", fontStyle: "italic" }}>
                            Chưa ghi nhận
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })()}

          <div style={styles.divider} />

          {/* Prematch History — gom theo side */}
          {prematchBySide.length > 0 && (
            <>
              <div style={styles.sectionHeader}>
                <span style={styles.sectionTitle}>PREMATCH HISTORY</span>
                <span style={styles.sectionPercent}>
                  {(() => {
                    const total = prematchBySide.reduce((s, x) => s + x.visibleCumDrop, 0);
                    const leading = Math.max(...prematchBySide.map((s) => s.visibleCumDrop));
                    return total > 0 ? Math.min(100, Math.round((leading / total) * 100)) : 0;
                  })()}%
                </span>
              </div>
              {renderPrematchSideHistorySections(prematchBySide, marketLabel, bet)}
              <div style={styles.divider} />
            </>
          )}

          {/* Live History — gom theo side + suspend events */}
          {(liveBySide.length > 0 || suspendRows.length > 0) && (
            <>
              <div style={styles.sectionHeader}>
                <span style={styles.sectionTitle}>LIVE HISTORY</span>
                <span style={styles.sectionPercent}>
                  {(() => {
                    const total = liveBySide.reduce((s, x) => s + x.visibleCumDrop, 0);
                    const leading = liveBySide.length > 0
                      ? Math.max(...liveBySide.map((x) => x.visibleCumDrop))
                      : 0;
                    return total > 0 ? Math.min(100, Math.round((leading / total) * 100)) : 0;
                  })()}%
                </span>
              </div>

              {liveBySide.map((s) => (
                <SideHistorySection
                  key={s.sideLabel}
                  sideLabel={s.sideLabel}
                  market={marketLabel}
                  percent={null}
                  items={s.drops}
                  summary={s.summary}
                />
              ))}

              {suspendRows.length > 0 && (
                <div style={styles.historySection}>
                  <div style={styles.sectionHeader}>
                    <span style={{
                      ...styles.sectionTitle,
                      color: "rgba(249,115,22,0.6)",
                      fontSize: "10px",
                      letterSpacing: "0.05em",
                    }}>
                      ĐÓNG / MỞ KÈO
                    </span>
                  </div>
                  {suspendRows.map((row, i) => (
                    <SuspendEventItem
                      key={`suspend-row-${i}`}
                      type={row.type}
                      timeStr={row.timeStr}
                      minute={row.minute}
                    />
                  ))}
                </div>
              )}
            </>
          )}

        </div>
      </div>
      </div> {/* fdp-scroll-body */}
    </div>
  );
}
